import { useMemo } from 'react';

import type { Permission } from '@/entities/permissions';
import { hasPermissionForTier } from '@/entities/permissions';
import { useAppSelector } from '@/store/hooks';

const usePermission = () => {
  const userTier = useAppSelector(state => state.user.userTier);
  const hasPermission = useMemo(
    () => (permission: Permission) => hasPermissionForTier(userTier, permission),
    [userTier]
  );
  return { tier: userTier, hasPermission };
};

export default usePermission;
